import React, { useEffect, useState } from 'react'
import CoursesList from './CoursesList'
import SetPage from '../../data/SetPage'
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import ModalStyle from '../../data/ModalStyle'
import Close from '@mui/icons-material/Close'
import { PlayCircle } from '@mui/icons-material'
import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet';
import img from "../../assets/images/connection/avatar10.jpg"
import img2 from "../../assets/images/course/preRecordedCourses.png"


const SelfpacedCourses = () => {

  useEffect(() => {
    SetPage("Selfpaced Courses")
    window.scrollTo(0, 0)
  }, [])
  const [demo, setdemo] = useState(false)
  return (
    <div className="pb-5 mb-5">

      <Helmet>‍
        <title>SiliconMinds - Selfpaced Courses | Selfpaced Training Programs</title>‍
        <meta name="description" content="Login into your account and learn the best skills from our curated courses" />
        <meta name="twitter:card" content="" />
        <meta name="twitter:site" content="@skillsuprise" />
        <meta name="twitter:creator" content="@skillsuprise" />
        <meta name="twitter:title" content="" />
        <meta name="twitter:description" content="" />
        <meta name="twitter:image" content="" />
        <meta property="og:title" content="" />
        <meta property="og:description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:site_name" content="Skills Uprise" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="fb:app_id" content="ID_APP_FACEBOOK" />
      </Helmet>


      <Modal
        open={demo}
        onClose={() => setdemo(false)}

      >
        <Box sx={ModalStyle} className="col-lg-4 col-md-5 br-5 col-sm-6 col-11 p-2">
          <div className="d-flex justify-content-between">
            <h4>Introduction</h4>
            <Close className="text-danger" type="button" onClick={() => setdemo(false)} />
          </div>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <video className="w-100" poster="https://skillsuprise.com/data/images/selfpaced-course-poster.png" autoPlay src="https://skillsuprise.com/data/videos/selfpaced-demo.mp4"></video>
          </Typography>
        </Box>
      </Modal>




      {/* <div className="selfpaced-crumb pb-5 bg-dark">

        <div className="container  d-flex justify-content-between flex-wrap text-white pt-2 pt-md-5">

          <div className="col-lg-5 col-12 col-sm-12 sm-mt-10">

            <img src="https://skillsuprise.com/resources/images/selfpaced-training.png" className="w-100 border border-2 border-secondary rounded" />

          </div>

          <div className="col-lg-7 sm-mt-30 ps-lg-3 p-0">
            <h1>Pre-Recorded Courses</h1>
            <div className=" mt-2">
              <hr />
              <h5 className="pb-0 mb-0 col-lg-9 col-12">Learn from the comforts of your home. Anytime, anywhere and experience a new standard of online trainings like never before</h5>

              <button onClick={() => setdemo(true)} className="btn btn-warning rounded-pill mt-3"><PlayCircle /> Watch Demo</button>


            </div>

          </div>






        </div>


      </div> */}

      <section className="banner-section offline-crumb self-placed-crumb">

        {/* Background Shapes */}
        <img className="img-fluid d-none d-lg-flex banner-bg1" src="/assets/img/bg/bg-15.png" alt="" />
        <img className="img-fluid d-none d-lg-flex banner-bg2" src="/assets/img/bg/bg-16.png" alt="" />
        <img className="img-fluid d-none d-lg-flex banner-bg3" src="/assets/img/bg/bg-17.png" alt="" />
        <img className="img-fluid d-none d-lg-flex banner-bg4" src="/assets/img/bg/bg-18.png" alt="" />

        <div className="container">
          <div className="row align-items-center justify-content-between">

            {/* LEFT CONTENT */}
            <div className="col-xl-7 col-lg-7 text-white">
              <div className="banner-content pe-lg-5">

                <span className="hero-title">
                  Self-Paced Online Learning
                </span>

                <h1 className="mb-4">
                  Pre-Recorded <span>Courses</span> Learn Anytime,{" "}
                  <span>Anywhere</span>
                </h1>

                <p className="fs-lg mb-4 text-light">
                  Learn from the comfort of your home with expertly designed
                  pre-recorded courses. Access content anytime, revisit lessons,
                  and build real-world skills at your own pace.
                </p>

                <button
                  onClick={() => setdemo(true)}
                  className="btn btn-orng rounded-pill px-4 py-2"
                >
                  <PlayCircle className="me-2" />
                  Watch Demo
                </button>

                {/* COUNTERS */}
                <div className="d-flex gap-4 flex-wrap mt-4 mb-2">
                  <div className="counter-item">
                    <div className="count-content">
                      <h5 className="text-warning mb-0">25K+</h5>
                      <p className="mb-0 text-light">Learners</p>
                    </div>
                  </div>

                  <div className="counter-item">
                    <div className="count-content">
                      <h5 className="text-info mb-0">300+</h5>
                      <p className="mb-0 text-light">Online Courses</p>
                    </div>
                  </div>

                  <div className="counter-item">
                    <div className="count-content">
                      <h5 className="text-light mb-0">Lifetime</h5>
                      <p className="mb-0 text-light">Access</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            {/* RIGHT CARD (TEXT ONLY CHANGES) */}
            <div className="col-xl-4 col-lg-5 d-none d-lg-block">
              <div className="banner-course-card">
                <div className="hero-course-card mb-5">

                  <div className="hero-course-image">
                    <img src={img2} alt="Course" />
                    <div className="hero-heart">❤</div>
                    <div className="hero-brand">N</div>
                  </div>

                  <div className="hero-course-body">
                    <div className="hero-author">
                      <img src={img} alt="Instructor" />
                      <span className="text-dark">David Benitz</span>
                      <span className="hero-category">Self-Paced</span>
                    </div>

                    <h5 className="text-dark">
                     Design for Testability (Pre-Recorded)
                    </h5>

                    <div className="hero-rating d-flex">
                      <div>⭐ 5.0 <span>(2,100 Reviews)</span></div>
                      {/* <button
                        onClick={() => setdemo(true)}
                        className="btn btn-orng rounded-pill px-2 py-1 ms-auto"
                      >
                        <PlayCircle className="me-2" />
                        Watch Demo
                      </button> */}
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <div className="container sm-p-0">

        <CoursesList mode={"selfpaced"} />
      </div>

    </div>
  )
}

export default SelfpacedCourses